<template>  
<div class="section">

  <va-card :loading="loading" :title="`Image analysis resualts: ${result.referance_id}`">
    <loading :active.sync="loading" :is-full-page="true"></loading>

    <div class="row align--top">

      <div class="flex xs12 md2 text-center">
        <img :src="result.referance_resource" class="image-single">
      </div>

      <div class="flex xs12 md10 ">
        
        <va-item>
          <va-item-section>
            <va-item-label>Reference ID:<strong>{{ result.referance_id }}</strong></va-item-label>
            <va-item-label caption>Specific resource identifier provided by queries resource</va-item-label>
          </va-item-section>
        </va-item>

        <va-item>
          <va-item-section>
            <va-item-label>Reference TYPE: <strong>{{ result.referance_type }}</strong></va-item-label>
            <va-item-label caption>Specific resource type provided by queries resource</va-item-label>

          </va-item-section>
        </va-item>

        <va-item>
          <va-item-section>
            <va-item-label>Reference Resource: <strong><a :href="result.referance_resource">{{ result.referance_resource }}</a></strong></va-item-label>
            <va-item-label caption>Link to resource usued to pull and process resource</va-item-label>
          </va-item-section>
        </va-item>

        <va-item>
          <va-item-section>
            <va-item-label>Job / Task ID: <strong>{{ result.task_id }}</strong></va-item-label>
            <va-item-label caption>Unique job/process identifier</va-item-label>
          </va-item-section>
        </va-item>

        <va-item>
          <va-item-section>
            <va-item-label>Reference Processed at: <strong>{{ result.created_at }}</strong></va-item-label>
            <va-item-label caption>Time the resource has been successfully processed by the system</va-item-label>
          </va-item-section>
        </va-item>

      </div>
    </div>

  </va-card>

  <va-card style="margin-top: 2.2rem" v-if="!channel_empty" :loading="loading" :title="$t('Cross resource analysis prossesing ...')">

    <div class="row align--center">

      <div class="flex xs12 md12 pr-4 pl-4 text-right" >
        <va-progress-bar style="transition: 0s !important;" color="info" :value="process_channel_data.data.percent">
          <span v-if="!channel_empty">{{parseFloat(process_channel_data.data.percent).toFixed(2)}}%</span>
          <span v-if="channel_empty"> Analysis completed</span>
        </va-progress-bar>
        <small style="opacity: 0.5" class="va-progress-bar__info">
        {{ process_channel_data.message }}<br>
          <span class="warning"> {{ process_channel_data.data.complete }} / {{ process_channel_data.data.total }}: Progress</span>
        </small>
      </div>

    </div>

  </va-card>

  <div class="flex xs12 md12 pt-4 pb-3 text-right">
    
    <va-button color="info" class="" target="_blank" :href="`https://www.google.com/searchbyimage?&image_url=${result.referance_resource}`">{{ $t('Search via google') }}</va-button>
    <va-button color="success" :disabled="!channel_empty" class="" @click="image_analysis">{{ $t('Start cross resource analysis') }}</va-button>

  </div>

  <div class="row align--center" v-if="channel_empty && analysis_results_current">
        
        <div class="flex xs12 md12">
          <va-card title="Cross resource analysis top 10 results">
            
            <p clas="">Analysis completed on {{ Date(analysis_results_current.created_at)}}</p><br>

            <va-data-table
              :fields="analysis_results.fields"
              :data="analysis_results_current.data"
              :loading="loading"
              :per-page="10"
              @row-clicked="gotTo"
              clickable
              hoverable
            >
                
              <template slot="variant" slot-scope="props">
                <img :src="props.rowData.variant"  class="image-single">
              </template>

              <template slot="match_percent" slot-scope="props">
                Percent: <strong>{{ parseFloat(props.rowData.match_percent).toFixed(2)}}%</strong> <br>
                Points: <strong>{{ props.rowData.matched_points }}</strong>
              </template>

            </va-data-table>

          </va-card>
        </div>
       

  </div>


</div>
</template>
<script>
  import Table from '../../ui/table/Table';
  import { socket } from '@/store/modules/image-analyst'
  import { mapActions, mapState, mapMutations, mapGetters } from 'vuex';
  import { debounce } from 'lodash'
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';

  export default {
    components: {
      Table,
      Loading
    },
    props: [],
    data () {
      return {
        loading: true,
        channel_empty:true,
        process_channel_data: {},
        analysis_results:{
          paginate: 10,
          totalPages: 0,
          data:{
            complete: 0,
            percent: 0,
            process_data: [],
            sql_resaults: false,
            total: 0
          },
          fields:[
            {
              name: '__slot:variant',
              title: 'Processed media:',
            },
            {
              name: 'referance_type',
              title: 'Resource type:',
            },
            {
              name: 'referance_id',
              title: 'Resource identifier:',
            },
            {
              name: 'system_id',
              title: 'System identifier:',
            },
            {
              name: '__slot:match_percent',
              title: 'Estimated match:',
            },
          ]
        }
      }
    },
    watch:{
      $route (to, from){
          this.request()
      }
    },
    computed: {

      ...mapState({
        result: state => state.imageAnalyst.long_term_result_view,
        client: state => state.imageAnalyst.client
      }),

      analysis_results_current(){

        if(!this.result.hasOwnProperty('media_analysis_results')){
          return false
        }

        if(this.result.media_analysis_results.length <= 0){
          return false
        }

        return this.result.media_analysis_results[this.result.media_analysis_results.length - 1]
      }

    },
    methods: {

      ...mapActions({
        fetch: 'fetchLongTermResultView',
        compare_analysis: 'postRequestImageComparison'
      }),

      /**
       * Open new socket tunnel for process monitoring 
       */
      connect_tunnel(){

        socket.on(`comparison[${this.$route.params.id}]`,(message) => {

         if (message.data.data) {
          this.process_channel_data = message.data
          this.channel_empty        = false       
        }

        this.process_channel_data.message = message.data.message

        if( message.data.status == "complete"){

          this.channel_empty = true;
          this.request()

        }


      });
        this.loading = false
      },

      /**
       * Go to specified resource
       * @param row
       * @return void
       */
      gotTo(row){
        this.$router.push({ name: 'ImageAnalystResultsSingle', params: { id: row.system_id }})
      },

      /**
       * Request routed resource 
       * @return void
       */
      request(){

        this.loading = true
        this.fetch(this.$route.params.id).then( response => { 

          this.totalPages = response.pages
          this.loading    = false
          this.connect_tunnel()

        })

      },

      /**
       * Request new image analysis process to start 
       */
      image_analysis(){

        this.loading = true
        this.compare_analysis({"result_id":this.result.id,"type":this.result.referance_type,"id":this.result.referance_id}).then( response => { 
          this.loading = false 
        })

      }

    },

    mounted(){
      this.request()
    },

    destroy(){
      this.process_channel_data = {}
      socket.disconnect();
    }

  }
</script>
<style >

.va-progress-bar__overlay{
  transition: width ease 0s !important
}

.image-single {
  width: 150px;
  height: auto;
  border-radius: 50%;
}

ul.console {
  padding: 1rem;
  background: #000;
  max-height: 80vh;
  overflow: auto;
  color: #1daf24;
  border-radius: 0.25rem;
}

li.line-item {
  font-family: monospace;
}


</style>
